<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Kode Voucher ({{voucher.name}})</h5>
      </template>
      <div class="search-wrapper d-flex align-items-center justify-content-between">
        <b-form-group
          label="Filter"
          label-for="filterInput"
          class="form-inline form-group-wrapper mb-3"
        >
          <div class="d-flex search-input-wrapper ml-2">
            <b-form-input
              class="mr-2"
              v-model="input.filterCode"
              name="filterTable"
              type="search"
              id="filterInput"
              placeholder="Kode"
              @keyup.enter="onFilter"
            ></b-form-input>
            <b-form-select
              class="ml-2 mr-2"
              v-model="input.filterIsActive"
              id="filterInput"
              name="levelRole"
              :options="optionStatus"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>Status</b-form-select-option>
              </template>
            </b-form-select>
            <b-button
              class="mr-2"
              variant="pgiBtn"
              :disabled="isBusy"
              name="searchTableBtn"
              @click="onFilter"
            >
              <i class="fa fa-search"></i>
            </b-button>
            <b-button
              variant="pgiBtn"
              name="reseFilterBtn"
              :disabled="isBusy"
              @click="onReset"
              >Reset</b-button
            >
          </div>
        </b-form-group>
        <b-button class="mb-3" variant="pgiBtn" name="voucherAddBtn" @click="showModal=true"
          >Tambah Kode</b-button
        >
      </div>
      <b-table
        bordered
        hover
        show-empty
        :busy="isBusy"
        :items="items"
        :fields="fields"
        :no-local-sorting="false"
        @sort-changed="sortingChanged"
        responsive
        class="mb-3"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading data...</strong>
          </div>
        </template>
        <template v-slot:empty> Tidak ada data Voucher. </template>
        <template v-slot:cell(type)="row">
          {{ getVoucherType(row.item.type) }}
        </template>
        <template v-slot:cell(isActive)="row">
          <b-badge variant="primary" class="p-2" v-if="row.item.isActive == true"
            >Aktif</b-badge
          >
          <b-badge variant="danger" class="p-2" v-else>Tidak Aktif</b-badge>
        </template>
        <template v-slot:cell(action)="row">
          <div class="no-wrap d-flex align-items-center">
            <!-- Toggle Active -->
            <b-button
            v-if="row.item.isActive"
            size="sm"
            :variant="row.item.isActive ? 'danger' : 'success'"
            v-b-tooltip.hover
            :title="row.item.isActive ? 'Nonaktifkan' : 'Aktifkan'"
            @click="confirmToggle(row.item)"
            >
            {{ row.item.isActive ? "Nonaktifkan" : "Aktifkan" }}
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="pagination-wrapper d-flex align-items-center justify-content-between">
        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
          <b-form-select
            v-model="input.show"
            id="showItems"
            :options="options"
            @change="onLimitChange"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled />
            </template>
          </b-form-select>
          <span class="ml-2">{{ totalViewText }}</span>
        </b-input-group>
        <b-pagination
          class="mb-0"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          @input="onPageChange"
        ></b-pagination>
      </div>
    </b-card>

    <!-- Modal Upload Kode -->
    <b-modal v-model="showModal" title="Tambah Kode Voucher" hide-footer>
      <b-form @submit.prevent="submitForm">
        <b-form-group label="Upload File (.csv)">
          <div
            class="drag-drop-area"
            @dragover.prevent
            @dragenter.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="handleDrop"
            :class="{ 'is-dragover': isDragging }"
          >
            <p v-if="!csvFile">
              Seret dan lepas file CSV di sini, atau klik untuk memilih
            </p>
            <p v-else>File terpilih: {{ csvFile.name }}</p>

            <input
              ref="fileInput"
              type="file"
              accept=".csv"
              class="d-none"
              @change="handleFileChange"
            />

            <b-button
              v-if="!csvFile"
              variant="outline-primary"
              @click="triggerFileSelect"
            >
              Pilih File
            </b-button>

            <b-button v-else variant="outline-danger" @click="removeFile">
              <b-icon icon="x" /> Hapus File
            </b-button>
          </div>
        </b-form-group>
        <b-button variant="pgiBtn" type="submit" :disabled="isSubmitting"
          >Upload</b-button
        >
      </b-form>
    </b-modal>
    <b-modal
    id="confirm-toggle-modal"
    v-model="showConfirmModal"
    :title="modalTitle"
    @ok="proceedToggle"
    >
    <div>
    {{ modalMessage }}
    </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      fields: [
        { key: "code", label: "Kode" },
        { key: "isActive", label: "Status" },
        { key: "action", label: "Aksi" },
      ],

      input: {
        show: 10,
        filterCode: null,
        filterIsActive: null,
        sortBy: "id",
        sortDesc: "desc",
      },
      isBusy: true,
      initStatus: 0,
      showModal: false,
      csvFile: null,
      isDragging: false,
      isSubmitting: false,
      voucherId: this.$route.params.id,
      filterCode: "",
      filterStatus: null,
      filter: null,
      currentPage: 1,
      perPage: 10,
      rows: null,
      totalViewText: "",
      page: "",
      size: "",
      loading: false,
      query: "",
      voucher:{},
      showConfirmModal: false,
      selectedVoucher: null,
      modalTitle: '',
      modalMessage: '',
      optionStatus: [
        { id: true, name: "Aktif" },
        { id: false, name: "Tidak Aktif" },
      ],
      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 40, text: "40" },
        { value: 50, text: "50" },
      ],
    };
  },
  methods: {
    init() {
      this.initStatus = 0;
      this.page = 0;
      this.size = this.input.show;
      this.query = this.$helper.makeQuery(this.page, this.size);

      let getVoucher = this.$axios.get(`/voucher-code/`+this.query+`&voucherId=${this.voucherId}`).then((response) => {
        this.items = response.data.data;
        this.updateTotalItem(response.data.total);
      });

      Promise.all([getVoucher])
        .then(() => {
          this.initStatus = 1;
          this.toggleBusy();
        })
        .catch((error) => {
          console.log(error);
          this.initStatus = -1;
        });
    },

    //----------------- Fungsi Ambil Data Voucher -----------------

    getVoucher() {
      this.toggleBusy();
      this.items = [];

      if (this.input.filterCode != null)
        this.query = this.query + "&filterCode=" + this.input.filterCode;
      if (this.input.filterIsActive != null)
        this.query = this.query + "&filterIsActive=" + this.input.filterIsActive;

      this.$axios
        .get(`/voucher-code/`+this.query+`&voucherId=${this.voucherId}`)
        .then((response) => {
          this.items = response.data.data;
          this.toggleBusy();
          this.updateTotalItem(response.data.total);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.reason);
          this.$helper.parseError(this, error);
          this.toggleBusy();
          this.loading = false;
        });
    },

    //----------------- Fungsi Pagination, Sorting, dan loading -----------------

    onLimitChange() {
      this.size = this.input.show;
      this.perPage = this.input.show;
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.getVoucher();
    },

    onPageChange() {
      if (this.loading == false) {
        this.page = this.currentPage - 1;
        this.query = this.$helper.makeQuery(this.page, this.size);
        this.getVoucher();
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy != "") {
        this.input.sortBy = ctx.sortBy;
        this.input.sortDesc = ctx.sortDesc;
        this.onFilter();
      }
    },

    onReset() {
      this.input.filterType = null;
      this.input.filterCode = null;
      this.input.filterIsActive = null;
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.loading = true;
      this.getVoucher();
    },

    onFilter() {
      this.page = 0;
      this.currentPage = 1;
      this.query = this.$helper.makeQuery(0, this.size);
      this.loading = true;
      this.getVoucher();
    },

    //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

    toggleBusy() {
      if (this.isBusy == true) this.isBusy = false;
      else this.isBusy = true;
    },

    updateTotalItem(total) {
      let limit = null;
      let prevLimit = null;
      this.perPage = this.size;
      this.rows = total;
      prevLimit = this.page * this.size + 1;
      limit = this.page * this.size + this.size;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },
    async submitForm() {
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append("voucherId", this.voucherId);
      formData.append("csv", this.csvFile);

      try {
        await this.$axios.post("/voucher-code/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.$bvToast.toast('Kode Voucher berhasil ditambahkan', {
            title: 'Sukses',
            variant: 'success',
            solid: true
        });
        this.showModal = false;
        this.csvFile = null;
        this.onReset();
      } catch (err) {
        this.$bvToast.toast(err.response.data.reason, {
            title: 'Error',
            variant: 'danger',
            solid: true
        });
        console.error("res",err.response);
      } finally {
        this.isSubmitting = false;
      }
    },

    async toggleVoucherStatus(id) {
        try {
        await this.$axios.get(`voucher-code/switch/${id}`);
        this.$bvToast.toast('Status kode voucher berhasil diubah', {
            title: 'Sukses',
            variant: 'success',
            solid: true
        });
        this.onReset()
        } catch (error) {
        this.$bvToast.toast('Gagal mengubah status kode voucher', {
            title: 'Error',
            variant: 'danger',
            solid: true
        });
        console.error(error);
        }
    },
    confirmToggle(voucher) {
      this.selectedVoucher = voucher;
      this.modalMessage = `Apakah Anda yakin ingin ${
        voucher.isActive ? 'menonaktifkan' : 'mengaktifkan'
      } kode voucher "${voucher.code}"?`;
       this.modalTitle = `Konfirmasi ${voucher.isActive ? 'Nonaktifkan' : 'Aktifkan'} Kode Voucher`;
      this.showConfirmModal = true;
    },
    proceedToggle() {
      if (this.selectedVoucher) {
        this.toggleVoucherStatus(this.selectedVoucher.id);
      }
    },

    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    handleDrop(e) {
      const files = e.dataTransfer.files;
      this.processFile(files[0]);
      this.isDragging = false;
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      this.processFile(file);
    },
    processFile(file) {
      if (file && (file.type === "text/csv" || file.name.endsWith(".csv"))) {
        this.csvFile = file;
      } else {
        alert("File harus berformat .csv");
      }
    },
    removeFile() {
      this.csvFile = null;
      this.$refs.fileInput.value = null;
    },
  },
  created() {
    this.init();
//     const rawData = this.$route.query.data;
//   if (rawData) {
//     this.voucher = JSON.parse(rawData);
//   }
  },
  mounted() {
  const rawData = this.$route.query.data;
  console.log("raw", rawData);
  
  if (rawData) {
    this.voucher = JSON.parse(rawData);
  }
}

};
</script>

<style scoped>
.drag-drop-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: background-color 0.2s ease;
  cursor: pointer;
}
.drag-drop-area.is-dragover {
  background-color: #f0f8ff;
  border-color: #007bff;
}
</style>
